<template>
  <a-data-table
    ref="scrollTable"
    :headers="headers"
    :items="feedbacks"
    :expanded.sync="expanded"
    item-key="id"
    show-expand
    class="elevation-1"
    single-expand
    dense
    fixed-header
    sort-by="topic_name"
    :must-sort="true"
    :no-data-text="$t('noData')"
    :footer-props="{ 'items-per-page-text': $t('lblRowsPerPage') }"
  >
    <template v-slot:[`item.topic_name`]="{ item }">
      <div class="overflow-wrap">
        {{ item.topic_name }}
      </div>
    </template>
    <template v-slot:[`item.agenda_name`]="{ item }">
      <div class="overflow-wrap">
        {{ item.agenda_name }}
      </div>
    </template>
    <template v-slot:item.data-table-expand="{ expand, isExpanded }">
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-icon
            v-bind="attrs"
            v-on="on"
            v-if="isExpanded"
            @click="expand(!isExpanded)"
            >mdi-chevron-up</v-icon
          >
          <v-icon v-bind="attrs" v-on="on" v-else @click="expand(!isExpanded)"
            >mdi-chevron-down</v-icon
          >
        </template>
        <span>{{ $t("statistics.lblRespondentResponse") }}</span>
      </v-tooltip>
    </template>
    <template v-slot:[`item.average_rating`]="{ item }">
      <v-rating
        background-color="orange lighten-3"
        color="orange"
        icon-label="Rating"
        length="5"
        :value="item.average_rating"
        half-increments
        readonly
      ></v-rating>
    </template>
    <template v-slot:[`item.topic_category`]="{ item }">
      {{ getTopicCategoryName(item.topic_category) }}
    </template>
    <template v-slot:[`item.start_date`]="{ item }">
      {{ formatDate(new Date(item.start_date), displayDateFormat) }}
    </template>
    <template v-slot:expanded-item="{ headers, item }">
      <!-- <td :colspan="headers.length">More info about {{ item.feedbacks }}</td> -->
      <td :colspan="headers.length" class="pa-4">
        <a-data-table
          :headers="innerHeaders"
          :items="item.feedbacks"
          dense
          item-key="id"
          class="elevation-1 timer-table"
          hide-default-footer
          fixed-header
        >
          <template v-slot:[`item.user_id`]="{ item }">
            <template v-if="item.user_id">
              <v-list-item
                v-for="(user, index) in getUsersDetails(item)"
                :key="index"
                style="max-height: 28px; min-height: auto"
                class="pl-0"
              >
                <v-list-item-avatar size="20" class="my-0 mr-2">
                  <v-img
                    v-if="user.profilePhoto"
                    contain
                    :src="user.profilePhoto"
                  ></v-img>
                  <v-img v-else src="@/assets/images/No-Photo.jpg"></v-img>
                </v-list-item-avatar>

                <v-list-item-content class="my-0">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-list-item-title
                        v-bind="attrs"
                        v-on="on"
                        class="text-truncate body-m"
                        style="max-width: 200px"
                        >{{
                          user.firstName
                            ? user.firstName + " " + user.lastName
                            : user.email
                        }}
                      </v-list-item-title>
                    </template>
                    <span>{{
                      user.firstName
                        ? user.firstName + " " + user.lastName
                        : user.email
                    }}</span>
                  </v-tooltip>
                </v-list-item-content>
              </v-list-item>
            </template>
            <v-list-item
              v-else
              style="max-height: 28px; min-height: auto"
              class="pl-0"
            >
              <v-list-item-avatar size="20" class="my-0 mr-2">
                <v-img src="@/assets/images/No-Photo.jpg"></v-img>
              </v-list-item-avatar>
              <v-list-item-content class="my-0">
                <v-list-item-title class="body-m" style="max-width: 200px"
                  >Anonymous
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
          <template v-slot:[`item.rating`]="{ item }">
            <v-rating
              background-color="orange lighten-3"
              color="orange"
              icon-label="Rating"
              length="5"
              :value="item.rating"
              half-increments
              readonly
            ></v-rating>
          </template>
        </a-data-table>
      </td>
    </template>
  </a-data-table>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import { formatDate } from "@/utils/util";

export default {
  name: "TopicFeedbackTable",
  props: {
    feedbacks: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      expanded: [],
      singleExpand: false,
      tableHeight: 400,
    };
  },
  mounted() {
    this.calculateTableHeight();
    window.addEventListener("resize", this.calculateTableHeight);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.calculateTableHeight);
  },
  computed: {
    ...mapState({
      userList: (state) => state.people.userList,
      deletedUserList: (state) => state.meeting.deletedUserList,
    }),
    locale() {
      return this.$i18n.locale;
    },
    displayDateFormat() {
      return this.locale !== "ja" ? "dd/MM/yyyy h:mm aaa" : "yyyy/MM/dd HH:mm";
    },
    ...mapGetters({
      tenantSettingTypes: "tenant/tenantSettingTypes",
    }),
    topicCategories() {
      return this.tenantSettingTypes("topiccategory");
    },
    innerHeaders() {
      return [
        {
          text: this.$t("poll.lblRespondent"),
          value: "user_id",
          class: "header header-text",
          width: "25%",
        },
        {
          text: this.$t("poll.lblRating"),
          value: "rating",
          class: "header header-text",
          width: "15%",
        },
        {
          text: this.$t("agenda.lblComment"),
          value: "comment",
          class: "header header-text",
        },
      ];
    },
    headers() {
      return [
        {
          text: this.$t("statistics.lblTopic"),
          value: "topic_name",
          class: "header header-text",
        },
        {
          text: this.$t("agenda.tipAgendaName"),
          value: "agenda_name",
          class: "header header-text",
        },
        {
          text: this.$t("agenda.tipAgendaCategoryName"),
          value: "agenda_category",
          class: "header header-text",
          width: "15%",
        },
        {
          text: this.$t("agenda.hTopicCategory"),
          value: "topic_category",
          class: "header header-text",
        },
        {
          text: this.$t("search.meetingName"),
          value: "meeting_name",
          class: "header header-text",
        },
        {
          text: this.$t("statistics.lblMeetingDateStart"),
          value: "start_date",
          class: "header header-text",
        },
        {
          text: this.$t("statistics.lblAverageRating"),
          value: "average_rating",
          class: "header header-text",
        },
      ];
    },
  },
  methods: {
    getUsersDetails,
    getTopicCategoryName,
    formatDate,
    calculateTableHeight,
  },
};

function calculateTableHeight() {
  const HEADER_HEIGHT = 64;
  const FOOTER_HEIGHT = 50;
  const PADDING = 100;

  const baseHeight =
    window.innerHeight - HEADER_HEIGHT - FOOTER_HEIGHT - PADDING;

  this.$nextTick(() => {
    const filterCardHeight =
      document.querySelector(".feedback_filter_card")?.clientHeight ?? 0;

    const tableWrapper = this.$refs.scrollTable?.$el.querySelector(
      ".v-data-table__wrapper"
    );

    if (tableWrapper) {
      const availableHeight = baseHeight - filterCardHeight;
      tableWrapper.style.maxHeight = `${availableHeight}px`;
      tableWrapper.style.overflowY = "auto";
    }
  });
}

function getTopicCategoryName(id) {
  const category = this.topicCategories.find((c) => c.id === id);
  if (category) {
    return category.name;
  }
  return "not found";
}

function getUsersDetails(userItem) {
  const id = userItem.user_id;
  let user = [];
  let localUserList = [...this.userList];
  localUserList = localUserList.concat(this.deletedUserList);
  const uData = localUserList.find((u) => u.id == id);
  if (uData) {
    user.push({
      id: uData.id,
      email: uData.email,
      firstName: uData ? uData.firstName : "",
      lastName: uData ? uData.lastName : "",
      profilePhoto: uData ? uData.profilePhoto : "",
      isAnonymous: userItem.is_anonymous,
    });
  }
  return user;
}
</script>

<style scoped>
::v-deep .v-data-footer__select .v-select {
  margin-top: 5px !important;
  margin-bottom: 5px !important;
}
</style>